// extracted by mini-css-extract-plugin
module.exports = {"input":"input-image_input__skRC9","delete":"input-image_delete__FXME6","image":"input-image_image__NN_t3","logo":"input-image_logo__VWp8w","text":"input-image_text___Isdq"};